import React from 'react';
import * as PropTypes from 'prop-types';
import DeviceChoice from "./DeviceChoice";

const DeviceChoices = (props) => {
  return (
    <div className="row col-10 offset-1 col-lg-12 offset-lg-0 px-1">
      {
        props.devices.map(device =>
          <DeviceChoice
            key={device.id}
            device={device}
            selectedDevice={props.selectedDevice}
            onHovered={device => props.onHovered(device)}
            onSelected={device => props.onDeviceSelected(device)}
            isClicked={props.selectedDevice ? props.selectedDevice.id === device.id : false}
          />
        )
      }

    </div>
  );
};

DeviceChoices.propTypes = {
  devices: PropTypes.array.isRequired,
  onHovered: PropTypes.func.isRequired,
  onDeviceSelected: PropTypes.func.isRequired,
  selectedDevice: PropTypes.object
};

export default DeviceChoices;